import { styled } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC, useMemo } from 'react'
import { ElfsightWidget } from 'react-elfsight-widget'
import { SectionWrapper } from './common/styles'

interface PropTypes {
  widgetLink?: string
  onClick?: () => void
}

const Header = styled('h1', { name: 'Header' })({
  fontSize: 24,
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  marginBottom: 20,
})

const formatWidgetId = (id: string) => {
  let i = 0
  return '########-####-####-####-############'.replace(/#/g, () => id[i++] || '')
}

const ELFSIGHT_ID_LENGTH = 49
const elfsightRegex = new RegExp(/^https:\/\/([A-Za-z0-9]{32})\.elf\.site$/)
export const validateElfsightLink = (link: string | undefined) => {
  if (!link) return undefined
  const matchResult = link.match(elfsightRegex)
  return matchResult && matchResult.length > 1 && link.length === ELFSIGHT_ID_LENGTH ? matchResult[1] : undefined
}

const parseWidgetId = (link: string | undefined) => {
  const cleanLink = link?.trim()
  const widgetId = validateElfsightLink(cleanLink)
  if (!widgetId) return undefined
  return formatWidgetId(widgetId)
}
const Socials: FC<PropTypes> = ({ widgetLink, onClick }) => {
  const translate = useTranslate()
  const widgetId = useMemo(() => parseWidgetId(widgetLink), [widgetLink])
  if (!widgetId) return null
  return (
    <SectionWrapper onClick={onClick}>
      <Header>{translate('Social')}</Header>
      <ElfsightWidget widgetId={widgetId} lazy />
    </SectionWrapper>
  )
}

export default Socials
